export default __webpack_public_path__ + "static/logo-tau-ai-te-ira-fa910915e20254e1920ce28e80b71dcc.png";